'use strict';
import axios from 'axios';
import shajs from 'sha.js';
import store from './store';

const encrypt = p =>
  shajs('sha256')
    .update(p)
    .digest('hex');

const finder = vm => async userid => {
  let dbuser;
  let sfuser;
  try {
    const res = await vm.get(`/user/${userid}`);
    dbuser = res.data.user;
    sfuser = null;
  } catch (error) {
    try {
      const res = await vm.get(`/thamesvalley/salesforce/${userid}`);
      sfuser = res.data.user;
      dbuser = null;
    } catch (error) {
      dbuser = null;
      sfuser = null;
    }
  }
  return {
    db: dbuser ? true : false,
    sf: sfuser ? true : false,
    found: !!dbuser || !!sfuser,
    user: dbuser ? dbuser : sfuser ? sfuser : null,
  };
};

/**
 *
 */
const http = (function() {
  /**
   * December 2025
   *
   * Switch all API traffic to TVAP owned Digital Ocean server.
   *
   * The path /thamesvalley/v1 will route to the legacy API codebase which is
   * on the same server as the newer Fastify API which will be used for all future
   * client side apps e.g. registration and the v2 booking app (if either gets deployed).
   *
   * The legacy codebase is an Express based server and is not being actively developed.
   */

  const SERVER_OPTS =
    process.env.NODE_ENV === 'development'
      ? { protocol: 'https', server: 'api.tvap.co.uk' }
      : { protocol: 'https', server: 'api.tvap.co.uk' };

  // An Axios instance that only addresses a specified server.
  const baseURL = `${SERVER_OPTS.protocol}://${SERVER_OPTS.server}/thamesvalley/v1`;
  console.log(`Connecting to: ${baseURL} in ${process.env.NODE_ENV} mode`);
  const h = axios.create({ baseURL });

  // Public API definitions
  const methods = { get: h.get, put: h.put, post: h.post };
  const removeToken = () => delete h.defaults.headers.common['Authorization'];
  const setToken = function(t) {
    h.defaults.headers.common['Authorization'] = t;
  };
  const getToken = () => h.defaults.headers.common['Authorization'];

  // Added a response interceptor to handle 401 response when session token
  // has expired.
  h.interceptors.response.use(
    response => {
      if (!response.data.success) {
        return Promise.reject({ message: response.data.message });
      }
      return response;
    },
    error => {
      return Promise.reject({
        status: error.response.status,
        ...error.response.data,
      });
    }
  );

  // Public API declaration
  return {
    ...methods,
    removeToken,
    getToken,
    setToken,
  };
})();

export { encrypt, finder, http, store };
